import useSWR from 'swr';

import { usePrivate } from '@/components/private/PrivateContext';
import { enqueueSnackbar } from '@/providers/SnackbarProvider';

import { useGetOrganisationsMessages } from './messages';

export interface useGetOrganisationsOptions {
  shouldFetch?: boolean;
}

export function useGetOrganisations(options?: useGetOrganisationsOptions) {
  const mergedOptions: useGetOrganisationsOptions = {
    shouldFetch: true,
    ...options,
  };

  const { organisationApi } = usePrivate();

  const results = useSWR(
    organisationApi && mergedOptions.shouldFetch ? '/api/Organisation' : null,
    () => organisationApi?.apiOrganisationGet(),
    {
      onError: (error) => {
        enqueueSnackbar(
          useGetOrganisationsMessages[
            'useGetOrganisations.fetch.unexpectedError'
          ],
          {
            variant: 'error',
          },
        );
        console.error(
          '[BREEDLOGIC] <useGetOrganisations> error fetching organisations.',
          error,
        );
      },
    },
  );

  const isLoadingOrValidating =
    results.isLoading || results.isValidating || !organisationApi;

  return { ...results, isLoadingOrValidating };
}
